import React from 'react';
import MDSpinner from "react-md-spinner";

class SMMaterialSpinner extends React.Component {
  render() {
    const c1 = '#76cce8', c2 = '#8fea86';
    return <MDSpinner color1={c1} color2={c2} color3={c1} color4={c2}size={40} />;
  }
}
export default SMMaterialSpinner;



// WEBPACK FOOTER //
// ./app/javascript/components/shared/SMMaterialSpinner.jsx